import script from "./LocationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationSettings.vue?vue&type=script&setup=true&lang=js"

import "./LocationSettings.vue?vue&type=style&index=0&id=6bd27dea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd27dea"]])

export default __exports__